module.exports = __webpack_public_path__ + "assets/img/kefu-d9034b11.png";